import store from '@/store'

export async function checkAuth () {

    if(!localStorage.getItem('user')){
        return false;
    }

    var user = JSON.parse(localStorage.getItem('user'));

    if (!user || !user.token){
        return false;
    }

    var now = new Date().getTime()/1000;
    if(+localStorage.getItem('expired_at') < now){

        if(user.refresh_token){

            var payload = {
                refresh_token: user.refresh_token
            }
            await store.dispatch("user/refreshToken", payload).then(resp => {
                if(resp.success){
                    return true;
                }else{
                    localStorage.setItem('expired_at', '')
                    localStorage.setItem('user', '')
                    store.commit('user/setLogged', false)
                    store.commit('user/setUser', {})
                    return false
                }

            });

        }else {

            localStorage.setItem('expired_at', '')
            localStorage.setItem('user', '')
            store.commit('user/setLogged', false)
            store.commit('user/setUser', {})
            return false

        }
    }else{
        store.commit('user/setLogged', true)
        store.commit('user/setUser', JSON.parse(localStorage.getItem('user')))
        return true
    }
}